import EvaluationThumbsSubtypeDetails from "../details/EvaluationThumbsSubtypeDetails";
import { BaseModuleSubtypeResponse } from "../../../../../../types/actionModule/baseModuleSubtype";
import { EvaluationThumbsSubtypeDataModel } from "../../../../../../types/actionModule/subtypes/evaluationThumbsModels";

interface Props {
    subtype: BaseModuleSubtypeResponse;
    subtypeData: EvaluationThumbsSubtypeDataModel;
}

export default function EvaluationThumbsSubtypeSummary(props: Props) {
    return <EvaluationThumbsSubtypeDetails {...props} />
}
